import { TranslationKeys } from '~frontend-common/i18n/english/error.i18n';

const keys: TranslationKeys = {
  error: {
    entryContainsErrors: 'Oops! Il manque une réponse. Cliquez sur "modifier" pour la corriger.',
    fourOfour: {
      headline: 'Ooops',
      subtitle: 'Nous ne trouvons pas la page que vous recherchez.',
      title: "Quelque chose s'est mal passé.",
    },
  },
};

export default keys;
